import { render, staticRenderFns } from "./DetVoyageReview.vue?vue&type=template&id=59a8ae1c&"
import script from "./DetVoyageReview.vue?vue&type=script&lang=js&"
export * from "./DetVoyageReview.vue?vue&type=script&lang=js&"
import style0 from "./DetVoyageReview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DetVoyageReview.vue"
export default component.exports